import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Homepage extends Component {
  render() {
    return (
      <div className="Homepage">
        <span>The resource requested is not found</span>
        <FontAwesomeIcon icon="shield-alt" />
      </div>
    );
  }
}

export default Homepage;